import appApi from '../../../../api/app-api';
import { CrmAccountsPaymentsReportRow } from '../../../../api/types/reports/crm/crm-accounts-payments-report.type';
import { AccountsPaymentsSideBarFilterType } from '../side-bar/accounts-payments-side-bar-filter.type';
import { displayErrorText } from '../../../../api/errors/api-error-codes';
import { toast } from 'react-toastify';

export const getCrmAccountsPaymentsReportOperation = async (
  filters: AccountsPaymentsSideBarFilterType,
  offset: number,
  limit: number,
  setData: (data: CrmAccountsPaymentsReportRow[]) => any,
  setTotal: (total: number) => any,
  setLoading: (loading: boolean) => any,
) => {
  try {
    setLoading(true);
    const res = await appApi.getCrmAccountsPaymentsReport({
      branchIds: filters.branchIds ?? [],
      crmAccountTypes: filters.crmAccountTypes ?? [],
      paymentMethods: filters.paymentMethods ?? [],
      minAmount:
        typeof filters.minAmount === 'number' ? filters.minAmount : undefined,
      maxAmount:
        typeof filters.maxAmount === 'number' ? filters.maxAmount : undefined,
      fromDate: filters.fromDate ?? null,
      toDate: filters.toDate ?? null,
      offset,
      limit,
    });

    if (res.data.errCode) {
      toast.warn(displayErrorText(res.data.errCode));
      setLoading(false);
      return;
    }

    setData(res.data.body.data ?? []);
    setTotal(res.data.body.total ?? 0);
    setLoading(false);
  } catch (e) {
    toast.error('משהו קרה, יש לנסות שוב בעוד מספר רגעים');
    setLoading(false);
  }
};
